import React, { createContext, useContext, useState } from 'react';
import { CaregiverData, ChildData } from '../types/user';

interface OnboardingContextType {
  caregiverData: Partial<CaregiverData> | null;
  childrenData: Partial<ChildData>[];
  completedChildrenData: any[];
  setCaregiverData: (data: Partial<CaregiverData>) => void;
  setChildrenData: (data: Partial<ChildData>[]) => void;
  setCompletedChildrenData: (data: any[]) => void;
  updateChildData: (index: number, data: Partial<ChildData>) => void;
  resetOnboarding: () => void;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export function useOnboarding() {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
}

interface OnboardingProviderProps {
  children: React.ReactNode;
}

export function OnboardingProvider({ children }: OnboardingProviderProps) {
  const [caregiverData, setCaregiverData] = useState<Partial<CaregiverData> | null>(null);
  const [childrenData, setChildrenData] = useState<Partial<ChildData>[]>([]);
  const [completedChildrenData, setCompletedChildrenData] = useState<any[]>([]);

  const updateChildData = (index: number, data: Partial<ChildData>) => {
    setChildrenData(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], ...data };
      return updated;
    });
  };

  const resetOnboarding = () => {
    setCaregiverData(null);
    setChildrenData([]);
    setCompletedChildrenData([]);
  };

  return (
    <OnboardingContext.Provider
      value={{
        caregiverData,
        childrenData,
        completedChildrenData,
        setCaregiverData,
        setChildrenData,
        setCompletedChildrenData,
        updateChildData,
        resetOnboarding,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
}